import { z } from 'zod/v4';

export const UflpaEntitySchema = z.object({
  id: z.string(),
  name: z.string(),
  location: z.string().nullable(),
  effectiveDate: z.date(),
  aliases: z.array(z.string()).nullable(),
  flags: z.array(z.string()).nullable(),
  sourceText: z.string(),
  remarks: z.string().nullable(),
  createdAt: z.date(),
  lastCheckedAt: z.date(),
  facilityProcesses: z.array(z.string()).nullable(),
  sourceTextHash: z.string(),
});

export type UflpaEntity = z.infer<typeof UflpaEntitySchema>;

export const UpsertUflpaEntityParamsSchema = UflpaEntitySchema;
export type UpsertUflpaEntityParams = UflpaEntity;
